<template>
  <v-carousel
    dark
    :height="computeHeight ? computedHeight : height"
    hide-delimiters
    :show-arrows-on-hover="!isMobile"
  >
    <template v-slot:prev="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on">mdi-chevron-left</v-icon>
    </template>
    <template v-slot:next="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
    </template>
    <v-carousel-item
      v-for="(photo, i) in photos"
      :key="i"
      :src="photo"
      :class="padding"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  props: {
    photos: {
      type: Array,
      required: true
    },
    height: {
      type: String,
      required: true
    },
    padding: {
      type: String,
      required: true
    },
    computeHeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMobile() {
      return ["sm", "xs"].includes(this.$vuetify.breakpoint.name);
    },
    computedHeight() {
      if (this.isMobile) {
        return this.height / 2;
      } else {
        return this.height;
      }
    }
  }
};
</script>
